document.addEventListener("DOMContentLoaded", function () {

  function initUpsellSlider() {
    const cartDrawer = document.querySelector('.cart-drawer.is-open');
    const upsellEle = document.querySelector('.mm-upsell');

    if (!cartDrawer || !upsellEle) return;

    // Prevent re-initialization
    if (upsellEle.classList.contains('flickity-enabled')) return;

    let showArrows = upsellEle.children.length >= 2;

    new Flickity(upsellEle, {
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      focus: 'center',
      groupCells: true,
      prevNextButtons: showArrows
    });
  }

  // Run once on load (if already open)
  initUpsellSlider();

  // Observe cart drawer class changes
  const cartDrawer = document.querySelector('.cart-drawer');
  if (cartDrawer) {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === "class" &&
            cartDrawer.classList.contains("is-open")) {
          initUpsellSlider();
        }
      });
    });

    observer.observe(cartDrawer, { attributes: true });
  }
});

// document.querySelectorAll('.testimonials__slider, .carousel').forEach(slider => {
//   if (!slider.classList.contains('flickity-enabled')) {
//     new Flickity(slider, {
//       cellAlign: 'left',
//       contain: true,
//       pageDots: false,
//       groupCells: true
//     });
//   }
// });

document.addEventListener("DOMContentLoaded", function () {
document.querySelectorAll('.section-columns__slider, .testimonials__slider, .carousel').forEach(slider => {

  const isMobile = window.innerWidth <= 767;

    // If mobile and grid-mobile exists → skip Flickity
    if (isMobile && slider.classList.contains('grid--mobile')) return;

  if (!slider.classList.contains('flickity-enabled')) {
    new Flickity(slider, {
      cellAlign: 'center',
      contain: true,
      pageDots: false,
      groupCells: true
    });
  }
});
});

document.addEventListener("click", async (event) => {
  const button = event.target.closest("[data-share-button]");
  if (!button) return;

  event.preventDefault();

  const shareLink =
    button.getAttribute("data-share-link") || window.location.href;

  // 📱 MOBILE → Native share drawer (Amazon / Flipkart style)
  if (navigator.share) {
    try {
      await navigator.share({
        title: document.title,
        url: shareLink
      });
    } catch (err) {
      // User cancelled share – do nothing
    }
    return;
  }

  // 🖥 DESKTOP → Copy link fallback
  try {
    await navigator.clipboard.writeText(shareLink);

    const tooltip = button
      .closest(".share-button")
      ?.querySelector("[data-share-button-tooltip]");

    if (tooltip) {
      tooltip.classList.add("is-visible");
      setTimeout(() => {
        tooltip.classList.remove("is-visible");
      }, 1500);
    }
  } catch (err) {
    console.error("Copy failed", err);
  }
});


document.addEventListener("DOMContentLoaded", function () {

  document.addEventListener("click", function (e) {

    const navItem = e.target.closest(".product-navigation__item");
    if (!navItem) return;

    const sectionValue = navItem.getAttribute("data-navigation-section");
    console.log(sectionValue);
    if (!sectionValue) return;

    const target = document.querySelector(
      `[id^="${sectionValue}"]`
    );

    console.log(target);

    if (!target) return;

    const trigger = target.querySelector("[data-collapsible-trigger]");
    const content = target.querySelector("[data-collapsible-container]");

    if (trigger && content) {
      trigger.classList.add("is-expanded");
      trigger.setAttribute("aria-expanded", "true");

      content.classList.add("is-expanded");
      content.setAttribute("aria-expanded", "true");
      content.style.maxHeight = "none";
      content.style.height = "auto";
    }

    const header = document.querySelector("header");
    const headerHeight = header ? header.offsetHeight : 0;
    const targetPosition = target.getBoundingClientRect().top + window.scrollY;

    window.scrollTo({
      top: targetPosition - headerHeight - 20,
      behavior: "smooth"
    });

  });

});


document.addEventListener("DOMContentLoaded", function () {

  const swatches = document.querySelectorAll('[style*="--swatch"]');

  console.log(swatches)

  swatches.forEach((swatch) => {

    const style = swatch.getAttribute("style");
    console.log(style)

    const match = style.match(/var\(--(.*?)\)/);
    console.log(match)

    if(!match) return;

    const colorName = match[1];

    const cssColor = getComputedStyle(document.documentElement)
      .getPropertyValue(`--${colorName}`);

      console.log(cssColor)

    if(!cssColor){

      const formatted = colorName
        .replace(/-/g," ")
        .replace(/\b\w/g,l=>l.toUpperCase());

      swatch.style.background = formatted;

    }

  });

});

